import { configureStore } from "@reduxjs/toolkit"; 
import notificationReducer from "./slices/admin/notificationSlice.js";

 

// Auth
import {authApi} from "./slices/auth/authSlice.js"
import {logoutApi} from "./slices/auth/logOutSlince.js" 

// Notifications
import {notificationApi} from "./slices/notifications/notificationSlice.js"

// ------------------------ Admin ------------------------ //

// Dashboard 
import {dhApi} from "./slices/admin/dashboard/dhSlince.js"


// Worker
import {newEmployeesApi} from "./slices/admin/workers/newEmployeeSlince.js"
import {usersApi} from "./slices/admin/workers/allUserSlince.js"
 
// Product
import {productApi} from "./slices/admin/product/newProduct.js"
import {manageProductsApi} from "./slices/admin/product/manageProducts.js"
import {manageProductsDeleteApi} from "./slices/admin/product/manageProductsDelete.js"
import {manageProductEditApi} from "./slices/admin/product/manageProductEditSlince.js"
import {archiveProductApi} from "./slices/admin/product/archiveProductSlince.js"
import {outOfStockApi} from "./slices/admin/product/outOfStockSlince.js"

// Payments
import {managePaymentsApi} from "./slices/admin/payment/paymentSlince.js"
import {totalEarningApi} from "./slices/admin/payment/totalEarningSlince.js"
 
// Machine
import {addCarApi} from "./slices/admin/machine/addCarSlince.js"
import {changeLogsApi} from "./slices/admin/machine/changeLogsSlince.js"
import {archivedCarsApi} from "./slices/admin/machine/archivedCarsSlince.js"
import {discountApi} from "./slices/admin/machine/priceDiscountSlince.js"

// Oil Requirements
import oilRequirementApi from "./slices/admin/oilRequirement/oilRequirementSlice.js"


// ------------------------ Seller ------------------------ //

// Sell
import {allCarPlateNumber} from "./slices/seller/sale/allCarPlateNumber.js"
import {allProductData} from "./slices/seller/sale/allProductSlince.js"
import {deleteSale} from "./slices/seller/sale/deleteSale.js"
import {sellerPaymentsApi} from "./slices/seller/payment/paymentSlince.js"
import {stockInfoApi} from "./slices/seller/products/stockInfoSlice.js"
import {archivedCarsSellerApi} from "./slices/seller/machine/archivedCarsSlince.js"
import {myLogsApi} from "./slices/seller/worker/myLogsSlince.js"


export const store = configureStore({
  reducer: {
 
    // Auth 
    [logoutApi.reducerPath]: logoutApi.reducer,

    // Notifications
    [notificationApi.reducerPath]: notificationApi.reducer,

    // ------------------------ Admin ------------------------ //

    // Dashboard 
    [dhApi.reducerPath]: dhApi.reducer,

    // Worker 
    [newEmployeesApi.reducerPath]: newEmployeesApi.reducer,
    [usersApi.reducerPath]: usersApi.reducer,
   
    // Product
    [productApi.reducerPath]: productApi.reducer,
    [manageProductsApi.reducerPath]: manageProductsApi.reducer,
    [manageProductsDeleteApi.reducerPath]: manageProductsDeleteApi.reducer,
    [manageProductEditApi.reducerPath]: manageProductEditApi.reducer,
    [archiveProductApi.reducerPath]: archiveProductApi.reducer,
    [outOfStockApi.reducerPath]: outOfStockApi.reducer,

    // Payments
    [managePaymentsApi.reducerPath]: managePaymentsApi.reducer,
    [totalEarningApi.reducerPath]: totalEarningApi.reducer,
  
 
    // Machine
    [addCarApi.reducerPath]: addCarApi.reducer,
    [changeLogsApi.reducerPath]: changeLogsApi.reducer,
    [archivedCarsApi.reducerPath]: archivedCarsApi.reducer,
    [discountApi.reducerPath]: discountApi.reducer,

    // Oil Requirements
    [oilRequirementApi.reducerPath]: oilRequirementApi.reducer,



    // ------------------------ Seller ------------------------ //

    // Sell
    [allCarPlateNumber.reducerPath]: allCarPlateNumber.reducer,
    [allProductData.reducerPath]: allProductData.reducer,
    [deleteSale.reducerPath]: deleteSale.reducer,
    [sellerPaymentsApi.reducerPath]: sellerPaymentsApi.reducer,
    [stockInfoApi.reducerPath]: stockInfoApi.reducer,
    [archivedCarsSellerApi.reducerPath]: archivedCarsSellerApi.reducer,
    [myLogsApi.reducerPath]: myLogsApi.reducer,

 


 
 
    notifications: notificationReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
 
      // Auth
      .concat(authApi.middleware)
      .concat(logoutApi.middleware)

      // Notifications
      .concat(notificationApi.middleware)

      // ------------------------ Admin ------------------------ //

      // Dashboard
      .concat(dhApi.middleware)

      // Worker 
      .concat(newEmployeesApi.middleware)
      .concat(usersApi.middleware)
   
      // Product
      .concat(productApi.middleware)
      .concat(manageProductsApi.middleware)
      .concat(manageProductsDeleteApi.middleware)
      .concat(manageProductEditApi.middleware)
      .concat(archiveProductApi.middleware)
      .concat(outOfStockApi.middleware)

      // Payment
      .concat(managePaymentsApi.middleware)
      .concat(totalEarningApi.middleware)
   
      // Machine
      .concat(addCarApi.middleware)
      .concat(changeLogsApi.middleware)
      .concat(archivedCarsApi.middleware)
      .concat(discountApi.middleware)

      // Oil Requirements
      .concat(oilRequirementApi.middleware)


      // ------------------------ Seller ------------------------

      // Sell
      .concat(allCarPlateNumber.middleware)
      .concat(allProductData.middleware)
      .concat(deleteSale.middleware)
      .concat(sellerPaymentsApi.middleware)
      .concat(stockInfoApi.middleware)
      .concat(archivedCarsSellerApi.middleware)
      .concat(myLogsApi.middleware)

 
 
});
